export default {
  'failed': '@:terms.transfer실패',
  'processing': '@:terms.transfer중',
  'completed': '@:terms.transfer완료',
  'pending': '@:terms.transfer@:terms.need',
  'invalid': '@:terms.transfer불가',
  'excluded': '@:terms.exception',
  'none-cert': '@:terms.certificate 미@:terms.register',
  'processing-cert': '@:terms.certificate @:terms.register중',
  'unavailable': '@:terms.transfer불가',
}
